<template>
  <div>
    <el-row class="cs-contentContainer">
      <el-col :span="4" class="cs-main-left-container">
        <navigator></navigator>
      </el-col>
      <el-col :span="20" class="backgroud-gray cs-fullHeight cs-main-right-container">
        <div class="cs-fullHeight cs-contentContainer-right">
          <div class="backgroud-white cs-contentContainer-right-content cs-fullHeight">
            <el-row>
              <span class="cs-title">渠道管理</span>
              <el-row class="grid-content">
                <el-row>
                  <el-col :span="20">&nbsp;</el-col>
                  <el-col v-if="!readonly" :span="4" class="text-right">
                    <el-button type="primary" @click="onAdd">添加渠道</el-button>
                  </el-col>
                </el-row>
                <el-row>
                  <pagination v-loading="loading" :data="listData" :option="paginationOption" @loadData="onLoadList" @pageSizeChange="pageSizeChange"
                    @currentPageChange="currentPageChange" @edit="onEdit" @delete="onDelete">
                    <template #PayeeType="{col, row}">
                      {{GLOBAL.enumPayeeType.getDesc(row[col.Name])}}
                    </template>
                    <template #EnableBottomPriceMode="{col, row, rowIndex}">
                      <span>{{row[col.Name] ? "是" : "否"}}</span>
                      <el-tooltip v-if="row[col.Name]" content="底价设置">
                        <el-button size="mini" icon="el-icon-s-tools" style="border: 0; background-color: transparent;" :plain="true" circle
                          @click="onBottomPriceSettingsClick(row, rowIndex)" />
                      </el-tooltip>
                    </template>
                  </pagination>
                </el-row>
              </el-row>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog center :title="channelEditorTitle" :close-on-click-modal="false" width="700px" :visible.sync="dialogEditorVisible" top="8vh">
      <channelEditor :dataIn="editData" @saveSuccess="onSaveSuccess"></channelEditor>
    </el-dialog>
    <channelBottomPriceEditor key="channelBottomPriceEditor" v-ref="(com, key) => $vueRefStore.setChildrenRef(key, com)" :readonly="readonly" :data="channelBottomPriceEditorOptions.dataIn" />
  </div>
</template>

<style lang="scss" scoped>
/deep/ body .el-table .el-table-header th {
  height: 30px;
  padding: 5px 0px;
  color: #909399 !important;
  background-color: #fff !important;
}

.cs-contentContainer {
  .grid-content {
    margin-top: 15px;
    /deep/ .el-table .el-table-header th {
      height: 30px;
      padding: 5px 0px;
      color: #909399 !important;
      background-color: #fff !important;
    }
  }
}
</style>

<script>
import navigator from "../../components/navigator";
import pagination from "../../components/common/pagination";
import channelEditor from "../../components/studyAbroad/channelEditor";
import {
  getChannelPageData,
  deleteChannel,
} from "../../service/studyAbroad.service";

export default {
  data() {
    return {
      readonly:
        !this.USERMANAGER.isAdmin && !this.USERMANAGER.isSABusinessManager && !this.USERMANAGER.isSAFinancialManager,
      pageSize: 20,
      currentPageNumber: 1,
      loading: false,
      paginationOption: {},
      editData: {},
      dialogEditorVisible: false,
      listData: {},
      channelEditorTitle: "",
      channelBottomPriceEditorOptions: {
        dataIn: null,
      },
    };
  },
  components: {
    navigator,
    pagination,
    channelEditor,
    channelBottomPriceEditor: () =>
      import("@/components/studyAbroad/channelBottomPriceEditor"),
  },
  computed: {},
  created() {
    this.paginationOption = {
      displayPagination: false,
      hasEditButton: !this.readonly,
      hasDeleteButtonWithEdit: !this.readonly,
      hasAddButton: false,
      addButtonText: "",
    };

    this.init();
  },
  methods: {
    init() {
      this.search();
    },
    search(pageNumber) {
      let pageData = this.getSearchPageData(pageNumber);
      this.loadListData(pageData);
    },
    loadListData(pageData) {
      this.loading = true;
      getChannelPageData(pageData)
        .then((result) => {
          if (!!result && result.success) {
            this.listData = result.data;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    pageSizeChange(value) {
      this.pageSize = value;
    },
    currentPageChange(value) {
      this.listData.CurrentPage = value;
    },
    getSearchPageData(pageNumber) {
      if (typeof pageNumber == "undefined") {
        pageNumber = 1;
      }

      this.currentPageNumber = pageNumber;

      let pageData = {
        pageSize: this.pageSize,
        pageNumber: pageNumber,
      };
      return pageData;
    },
    onLoadList(pageData) {
      this.search(pageData.pageNumber);
    },
    onEdit(index, row) {
      this.editData = { id: row.Id };
      this.channelEditorTitle = "编辑渠道";
      this.dialogEditorVisible = true;
    },
    onDelete(index, row) {
      this.$confirm(`您确定要删除渠道${row.Name}吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteChannel(row.Id).then((result) => {
            if (!!result && result.success) {
              this.search(this.currentPageNumber);
            }
          });
        })
        .catch(() => {});
    },
    onAdd() {
      this.editData = { id: null };
      this.channelEditorTitle = "添加渠道";
      this.dialogEditorVisible = true;
    },
    onSaveSuccess() {
      this.dialogEditorVisible = false;
      this.search(this.currentPageNumber);
    },
    openChannelBottomPriceEditor() {
      let channelBottomPriceEditor =
        this.$vueRefStore.getChildrenRef("channelBottomPriceEditor");
      if (!channelBottomPriceEditor) return;

      channelBottomPriceEditor.showDialog();
    },
    closeChannelBottomPriceEditor() {
      let channelBottomPriceEditor =
        this.$vueRefStore.getChildrenRef("channelBottomPriceEditor");
      if (!channelBottomPriceEditor) return;

      channelBottomPriceEditor.closeDialog();
    },
    onBottomPriceSettingsClick(row, index) {
      // console.log("onEditBottomPriceSettingsClick:", row, index);
      let dataIn = {
        Id: row.Id,
        Name: row.Name
      };
      this.channelBottomPriceEditorOptions.dataIn = dataIn;

      this.openChannelBottomPriceEditor();
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/page/studyAbroad/channelList.vue